export default "__VITE_ASSET__BBYl0Xl___"